import React from 'react';
import { Row, Col, Card, Statistic, Table, Typography } from 'antd';
import { analyticsDashboard } from '../../mockData';
import './Dashboard.css';

function AnalyticsDashboard() {
  const { Title } = Typography;

  const kpis = [
    { title: 'Impressions', value: analyticsDashboard.impressions.toLocaleString() },
    { title: 'Clicks', value: analyticsDashboard.clicks.toLocaleString() },
    { title: 'Conversions', value: analyticsDashboard.conversions.toLocaleString() },
    { title: 'Spend', value: `$${analyticsDashboard.spend.toLocaleString()}` },
  ];

  const columns = [
    { title: 'Client', dataIndex: 'name', key: 'name' },
    { title: 'Spend', dataIndex: 'spend', key: 'spend', align: 'right', render: (v) => `$${v.toLocaleString()}` },
  ];

  return (
    <div className="agency-analytics-dashboard">
      <Title level={3}>Global Performance Dashboard</Title>
      <Row gutter={[16, 16]}>
        {kpis.map((k) => (
          <Col xs={12} md={6} key={k.title}>
            <Card>
              <Statistic title={k.title} value={k.value} />
            </Card>
          </Col>
        ))}
      </Row>
      <Card style={{ marginTop: 16 }} title="Spend by Client">
        <Table
          rowKey={(r) => r.clientId}
          columns={columns}
          dataSource={analyticsDashboard.byClient}
          pagination={false}
        />
      </Card>
    </div>
  );
}

export default AnalyticsDashboard;
